export default __webpack_public_path__ + "static/soehne-web-buch-kursiv-59e7c9a4236fad036108db9f29ce9036.woff";